/* eslint-disable i18next/no-literal-string */
// @noflow
import { Factory } from 'fishery'

export default Factory.define(({ sequence }) => ({
  id: sequence,
  name: `Food Category ${sequence}`,
  slug: `food_category_${sequence}`
}))
